import React, { useEffect, useState } from "react";
import XLSX from 'xlsx';
import moment from 'moment-jalaali';
import { Form, Select } from 'antd';
import { useNavigate } from "react-router-dom";
import UserServices from "../../services/UserServices";
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function MarketerBalanceFilter() {
    const [form] = Form.useForm();
    const { business, users: usersState, FILTERED_ITEM, FILTER_USERS, GET_PROMOTERS } = usePersistedStore();
    const reports = useReportsStore()
    const navigate = useNavigate();
    const users = usersState.promoters;
    // const usersLoading = usersState.loading;
    const [usersLoading, setusersLoading] = useState(false);

    const filteredItem = usersState.filteredItem;
    const data = reports.balance.data;
    const loading = reports.balance.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const usersData = usersState.data;

    useEffect(() => {
        if (token) {
            form.resetFields()
        }
    }, [token]);

    useEffect(() => {

        if (!token)
            navigate('/dashboard');
        // dispatch(getPromoters());
        setusersLoading(true)
        reports.getMarketerBalance()
        UserServices.getPromoters(token).then((res) => {
            GET_PROMOTERS(res.data.Promoters)
            filterUsers(filteredItem)
            setusersLoading(false)
        }).catch((error) => {
            setusersLoading(false)
        })
      
    }, [navigate, token]);

    function filterUsers(value) {
        const payload = usersData.filter(item => {
            return (item.DisplayName && item.DisplayName.includes(value)) ||
                (item.Username && item.Username.includes(value));
        });
        FILTERED_ITEM(value)
        FILTER_USERS(payload)
    }
    function onFinish(values) {
        const userName = users?.filter(user => user.Title === values.UserName)[0].UserName;
        reports.getMarketerBalance(userName)
    }

    function downloadxlsx() {
        if (!data) return
        let xlsxData = data.map(d => [
            d.SummarizeAmount,
            d.Description,
            moment(d.Date).format('jYYYY/jMM/jDD')
        ])
        xlsxData.unshift(['مبلغ کل', 'توضیحات', 'تاریخ'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    return (
        <div className="header-page">
            <Form
                layout="inline" onFinish={onFinish} form={form}>
                <Form.Item

                    name='UserName'
                    label="کاربران:"
                >
                    <Select
                        showSearch
                        key={1}
                        loading={usersLoading}
                        disabled={!users.length || usersLoading}
                        style={{ minWidth: 300 }}>
                        {users && users.map((name, index) => {
                            return <Select.Option key={index} value={name.Title}>{name.Title}</Select.Option>
                        })}
                    </Select>
                </Form.Item>
                <Form.Item label=" " colon={false} style={{ marginLeft: "0px" }}>
                    <button
                        disabled={loading} type="primary"
                        className="btn btn-primary waves-effect waves-light" htmltype="submit">جستجو&nbsp;&nbsp;&nbsp;
                        <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                    </button>
                </Form.Item>
            </Form>
            <button type="primary" className="btn btn-success waves-effect waves-light" htmltype="submit"
                onClick={downloadxlsx}>
                <i className="far fa-file-excel font-size-14 align-middle mr-2"></i> دریافت اکسل
            </button>
        </div>
    )
}